const PAGE_DEFAULTS = {
  pageIcon: 'LuCreditCard',
  loadingMessage: 'Loading services...',
  popularBadgeLabel: 'Most Popular',
  buyNowLabel: 'Buy Now',
  loginToPurchaseLabel: 'Login to Purchase',
  alreadyPurchasedLabel: 'Already Purchased',
  stepHeaders: {
    1: { title: 'Pricing Plan', subtitle: 'Select the accounting service that fits your needs' },
    1.1: { title: 'USA Company Formation Details', subtitle: '' },
    1.25: { title: 'Select Hours for Pay-As-You-Go', subtitle: '' },
    1.5: { title: 'Tax Filing Details', subtitle: '' },
    2: { title: 'Select Your Location', subtitle: '' },
    3: { title: 'Order Summary', subtitle: '' },
  },
  stepTracker: {
    selectPlan: 'Select Plan',
    company: 'Company',
    hours: 'Hours',
    taxDetails: 'Tax Details',
    location: 'Location',
    checkout: 'Checkout',
  },
  slider: {
    maxDots: 6,
    priceIncrement: 60,
    baseExpense: 20000,
    expenseIncrement: 15000,
    labelPrefix: 'Up to',
    labelSuffix: 'in monthly expenses',
  },
  services: [],
  taxTypes: {},
  labels: {},
  companyFormation: {},
  hoursStep: {},
  taxStep: {},
  location: {},
  checkout: {},
  indianStates: [],
};

const FORMATION_DEFAULTS = {
  companyTypeTitle: 'Select Type of Company',
  stateTitle: 'Select State',
  einTitle: 'EIN Number',
  ssnQuestion: 'Do you have a Social Security Number (SSN)?',
  registeredAgentIncluded: '1st Year Registered Agent included',
  promoCodeTitle: 'Promo Code (Optional)',
  promoCodePlaceholder: 'Enter promo code',
  rewardPointsTitle: 'Reward Points',
  rewardPointsApply: 'Apply {points} reward points',
  rewardPointsApplied: '✓ {points} reward points will be applied',
  feesBreakdownTitle: 'Fees Breakdown',
  ourFeeLabel: 'Our Fee:',
  stateFeeLabel: 'State Fee:',
  einServiceLabel: 'EIN Service:',
  registeredAgentLabel: 'Registered Agent:',
  promoDiscountLabel: 'Promo Discount:',
  ourFeeAmount: 300,
  einYesPrice: 55,
  einNoPrice: 210,
  registeredAgentFee: 125,
  companyTypes: ['LLC', 'C-corporation'],
  usStates: ['Wyoming', 'Delaware', 'New Jersey', 'Texas'],
  stateFees: {
    LLC: { Wyoming: 104, Delaware: 110, 'New Jersey': 130, Texas: 310 },
    'C-corporation': { Wyoming: 104, Delaware: 109, 'New Jersey': 130, Texas: 310 },
  },
};

const LABEL_DEFAULTS = {
  back: 'Back',
  continue: 'Continue',
  proceed: 'Proceed',
  apply: 'Apply',
  applying: 'Applying...',
  remove: 'Remove',
  clear: 'Clear',
  save: 'Save',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  total: 'Total:',
  subtotal: 'Subtotal:',
  promoDiscount: 'Promo Discount:',
  referralDiscount: 'Referral Discount:',
};

const HOURS_STEP_DEFAULTS = {
  title: 'Number of Hours',
  hourlyRateLabel: 'Hourly Rate:',
  hoursSelectedLabel: 'Hours Selected:',
  totalAmountLabel: 'Total Amount:',
};

const TAX_STEP_DEFAULTS = {
  selectTaxTypeTitle: 'Select Tax Type',
  additionalQuestionsTitle: 'Additional Questions',
  priceSummaryTitle: 'Price Summary',
  basePriceLabel: 'Base Price:',
  businessTaxFilingLabel: 'Business Tax Filing',
  personalTaxFilingLabel: 'Personal Tax Filing',
  addOnsLabel: 'Selected add-ons:',
  yesPriceSuffix: '(+${price})',
  formQuestionsTitle: 'Form-specific questions',
  noFormsFallbackLabel: 'Questions',
};

const LOCATION_DEFAULTS = {
  sectionTitle: 'Select Payment Currency',
  internationalTitle: 'Outside India (USD)',
  internationalSubtitle: 'Pay in US Dollars',
  indiaTitle: 'India (INR, GST Applicable)',
  indiaRatePrefix: 'Current rate: 1 USD = ₹',
  selectStateLabel: 'Select State:',
  selectStatePlaceholder: '-- Select a State --',
};

const CHECKOUT_DEFAULTS = {
  orderDetailsTitle: 'Order Details',
  invoiceDetailsTitle: 'Details for Invoice',
  serviceLabel: 'Service:',
  companyTypeLabel: 'Company Type:',
  stateLabel: 'State:',
  taxTypeLabel: 'Tax Type:',
  hoursSelectedLabel: 'Hours Selected:',
  billingFrequencyLabel: 'Billing Frequency:',
  havePromoCodeLabel: 'Have a promo code?',
  enterCodePlaceholder: 'Enter code',
  useReferralCreditsLabel: 'Use Referral Credits',
  referralPointsHint: 'You have {points} points (Value: ${value})',
  proceedToPayPrefix: 'Proceed to Pay',
  fullNamePlaceholder: 'Full Name *',
  fullAddressPlaceholder: 'Full Address *',
  selectCountryLabel: 'Select Country: *',
  selectCountryPlaceholder: '-- Select a Country --',
  countryIndiaLabel: 'Country:',
  countryIndiaValue: 'India',
  invoiceStateLabel: 'State:',
  gstLabel: 'GST (18%)',
  gstinLabel: 'GSTIN:',
  addGstinLabel: '+ Add GSTIN',
  gstCgstBreakup: 'CGST: 9% + SGST: 9%',
  gstIgstBreakup: 'IGST: 18%',
  gstinModalTitle: 'Add GSTIN Number',
  gstinModalSubtitle: 'Enter your 15-digit GSTIN for invoice purposes (optional)',
  gstinPlaceholder: 'Enter GSTIN',
  gstinInvalidMessage: 'Please enter a valid GSTIN number',
  selectStateWarning: 'Please select a state',
};

export const getServiceBadgeMeta = (service, pageMeta) => {
  const visible = !!(service?.showBadge ?? service?.popular);
  const label = (service?.badgeLabel || '').trim() || pageMeta?.popularBadgeLabel || 'Most Popular';
  const styles = {
    primary: 'bg-gradient-to-r from-primary-500 to-primary-600',
    success: 'bg-gradient-to-r from-green-500 to-green-600',
    amber: 'bg-gradient-to-r from-amber-500 to-amber-600',
    rose: 'bg-gradient-to-r from-rose-500 to-rose-600',
    slate: 'bg-gradient-to-r from-slate-500 to-slate-600',
  };
  return {
    visible,
    label,
    styleClass: styles[service?.badgeStyle] || styles.primary,
  };
};

export const getPricingPageMeta = (content) => ({
  ...PAGE_DEFAULTS,
  ...(content || {}),
  stepHeaders: { ...PAGE_DEFAULTS.stepHeaders, ...(content?.stepHeaders || {}) },
  stepTracker: { ...PAGE_DEFAULTS.stepTracker, ...(content?.stepTracker || {}) },
  slider: { ...PAGE_DEFAULTS.slider, ...(content?.slider || {}) },
  labels: { ...LABEL_DEFAULTS, ...(content?.labels || {}) },
  companyFormation: { ...FORMATION_DEFAULTS, ...(content?.companyFormation || {}) },
  hoursStep: { ...HOURS_STEP_DEFAULTS, ...(content?.hoursStep || {}) },
  taxStep: { ...TAX_STEP_DEFAULTS, ...(content?.taxStep || {}) },
  location: { ...LOCATION_DEFAULTS, ...(content?.location || {}) },
  checkout: { ...CHECKOUT_DEFAULTS, ...(content?.checkout || {}) },
  indianStates: content?.indianStates?.length ? content.indianStates : [],
});

export const getCompanyFormationConfig = (content) => {
  const meta = getPricingPageMeta(content);
  const cf = meta.companyFormation || FORMATION_DEFAULTS;
  return {
    ...FORMATION_DEFAULTS,
    ...cf,
    stateFees: { ...FORMATION_DEFAULTS.stateFees, ...(cf.stateFees || {}) },
  };
};

export const getIndianStates = (content) => {
  const meta = getPricingPageMeta(content);
  if (meta.indianStates?.length) return meta.indianStates;
  return [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
    'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
    'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  ];
};

export const formatTemplate = (template, vars = {}) =>
  (template || '').replace(/\{(\w+)\}/g, (_, key) => (vars[key] !== undefined ? vars[key] : `{${key}}`));

export const normalizeUsdPrice = (value, fallback = 0) => {
  const n = Number(value);
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : fallback;
};

export const getPricingStepHeader = (meta, step) => {
  const headers = meta?.stepHeaders || PAGE_DEFAULTS.stepHeaders;
  return headers[step] || headers[String(step)] || headers[1] || { title: 'Pricing Plan', subtitle: '' };
};

export const getTaxTypeDetails = (content) => {
  const meta = getPricingPageMeta(content);
  const taxTypes = meta.taxTypes || {};
  const normalizeType = (type, fallback) => {
    const data = taxTypes[type] || fallback || { title: '', questions: [] };
    const questions = (data.questions || [])
      .filter((q) => q.isActive !== false)
      .map((q, index) => ({
        ...q,
        id: q.id || `${type}_q_${index + 1}`,
        price: normalizeUsdPrice(q.price),
      }));
    const forms = (data.forms || []).length
      ? [...data.forms]
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
          .map((form, index) => ({
            ...form,
            id: form.id || `${type}_form_${index + 1}`,
          }))
      : [{ id: `${type}_default`, name: data.formGroupLabel || TAX_STEP_DEFAULTS.noFormsFallbackLabel, order: 0 }];
    return {
      title: data.title || '',
      subtitle: data.subtitle || '',
      isActive: data.isActive !== false,
      forms,
      questions,
    };
  };
  return {
    business: normalizeType('business', { title: '', questions: [] }),
    personal: normalizeType('personal', { title: '', questions: [] }),
  };
};

export const buildInitialTaxAnswers = (questions = []) =>
  Object.fromEntries((questions || []).map((question) => [question.id, false]));

export const groupTaxQuestionsByForm = (taxTypeData) => {
  if (!taxTypeData) return [];
  const forms = taxTypeData.forms?.length
    ? taxTypeData.forms
    : [{ id: `${taxTypeData.id || 'tax'}_default`, name: TAX_STEP_DEFAULTS.noFormsFallbackLabel, order: 0 }];
  const defaultFormId = forms[0]?.id;

  return forms
    .map((form) => ({
      ...form,
      questions: (taxTypeData.questions || []).filter((question) => {
        const formId = question.formId || defaultFormId;
        return formId === form.id;
      }),
    }))
    .filter((group) => group.questions.length > 0);
};

export const getActiveTaxTypes = (taxTypeDetails) =>
  ['business', 'personal'].filter((type) => taxTypeDetails?.[type]?.isActive !== false);

export const buildPricingServices = (content, sliderValue = 1, quickPaymentCard = null) => {
  const meta = getPricingPageMeta(content);
  const { priceIncrement } = meta.slider;
  const formationOurFee = meta.companyFormation?.ourFeeAmount;

  return (meta.services || [])
    .filter((item) => item.isActive !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((service) => {
      let price = service.basePrice ?? service.price ?? 0;

      if (service._id === 'service_1' && formationOurFee != null && formationOurFee !== '') {
        price = normalizeUsdPrice(formationOurFee);
      } else if (service.sliderPricingType === 'bookkeeping') {
        price = computeSliderPrice(service.basePrice ?? 100, sliderValue, priceIncrement);
      } else if (service.sliderPricingType === 'cfo') {
        price = computeSliderPrice(service.basePrice ?? 200, sliderValue, priceIncrement);
      }

      const built = {
        ...service,
        price,
        details: (service.details || []).filter(Boolean),
      };

      if (service.usesQuickPaymentApi && quickPaymentCard) {
        built.name = quickPaymentCard.name || built.name;
        built.price = quickPaymentCard.price ?? built.price;
        built.details = quickPaymentCard.details?.length ? quickPaymentCard.details : built.details;
      }

      return built;
    });
};

export const getSliderExpenseAmount = (meta, sliderValue) => {
  const slider = meta?.slider || PAGE_DEFAULTS.slider;
  return slider.baseExpense + (sliderValue - 1) * slider.expenseIncrement;
};

export const getFormationOurFee = (service, formationConfig) =>
  normalizeUsdPrice(
    formationConfig?.ourFeeAmount ?? service?.price ?? service?.basePrice,
    300
  );

export const calculateFormationSubtotal = ({
  service,
  formationConfig,
  stateFees,
  companyType,
  selectedState,
  hasSSN,
  registeredAgent,
}) => {
  const baseFee = getFormationOurFee(service, formationConfig);
  const stateFee =
    companyType && selectedState && stateFees?.[companyType]?.[selectedState]
      ? normalizeUsdPrice(stateFees[companyType][selectedState])
      : 0;
  const einFee =
    hasSSN === true
      ? normalizeUsdPrice(formationConfig?.einYesPrice, 55)
      : hasSSN === false
        ? normalizeUsdPrice(formationConfig?.einNoPrice, 210)
        : 0;
  const raFee = registeredAgent === false ? normalizeUsdPrice(formationConfig?.registeredAgentFee, 125) : 0;
  return {
    baseFee,
    stateFee,
    einFee,
    raFee,
    subtotal: baseFee + stateFee + einFee + raFee,
  };
};

export const getPromoDiscount = (promoCodeDetails, discountableAmount) => {
  if (!promoCodeDetails || discountableAmount <= 0) return 0;
  if (promoCodeDetails.discountType === 'fixed') {
    return Math.min(Number(promoCodeDetails.discountValue) || 0, discountableAmount);
  }
  const pct = Number(promoCodeDetails.discountValue ?? promoCodeDetails.discountPercentage) || 0;
  return discountableAmount * (pct / 100);
};

export const getFormationDiscountableAmount = (breakdown, applicableFee) => {
  if (!breakdown) return 0;
  if (applicableFee === 'Our Fee') return breakdown.baseFee;
  if (applicableFee === 'State Fee') return breakdown.stateFee;
  if (applicableFee === 'EIN Service') return breakdown.einFee;
  if (applicableFee === 'Registered Agent') return breakdown.raFee;
  return breakdown.subtotal;
};

export const getPromoDisplayLabel = (promoCodeDetails) => {
  if (!promoCodeDetails) return '';
  if (promoCodeDetails.discountType === 'fixed') {
    return `$${promoCodeDetails.discountValue} off`;
  }
  const pct = Number(promoCodeDetails.discountValue ?? promoCodeDetails.discountPercentage) || 0;
  return `${pct}% off`;
};

export const formatPriceForLocation = (usdAmount, { location, exchangeRate }) => {
  const amount = Number(usdAmount) || 0;
  if (location === 'india') return `₹${(amount * exchangeRate).toFixed(2)}`;
  return `$${amount.toFixed(2)}`;
};

export const calculateOrderTotalUSD = ({
  service,
  formationConfig,
  stateFees,
  companyType,
  selectedState,
  hasSSN,
  registeredAgent,
  additionalPrice = 0,
  hours = 1,
  promoCodeDetails,
  applyReferralCredit = false,
  referralCredits = 0,
}) => {
  if (!service) {
    return { subtotalUsd: 0, discount: 0, referralDiscount: 0, totalUsd: 0 };
  }

  let subtotalUsd = Number(service.price) || 0;
  let discount = 0;
  let referralDiscount = 0;

  if (service._id === 'service_1') {
    const breakdown = calculateFormationSubtotal({
      service,
      formationConfig,
      stateFees,
      companyType,
      selectedState,
      hasSSN,
      registeredAgent,
    });
    subtotalUsd = breakdown.subtotal;

    if (promoCodeDetails) {
      const discountable = getFormationDiscountableAmount(breakdown, promoCodeDetails.applicableFee);
      discount = getPromoDiscount(promoCodeDetails, discountable);
    }
  } else if (service._id === 'service_2') {
    subtotalUsd += Number(additionalPrice) || 0;
    if (promoCodeDetails) discount = getPromoDiscount(promoCodeDetails, subtotalUsd);
  } else if (service._id === 'service_3') {
    subtotalUsd *= Number(hours) || 1;
    if (promoCodeDetails) discount = getPromoDiscount(promoCodeDetails, subtotalUsd);
  } else if (promoCodeDetails) {
    discount = getPromoDiscount(promoCodeDetails, subtotalUsd);
  }

  let totalUsd = subtotalUsd - discount;

  if (applyReferralCredit && referralCredits > 0 && service._id !== 'service_3') {
    const dollarValue = (referralCredits / 1000) * 5;
    referralDiscount = Math.min(dollarValue, totalUsd);
    totalUsd -= referralDiscount;
  }

  return { subtotalUsd, discount, referralDiscount, totalUsd: Math.max(0, totalUsd) };
};

export const toCheckoutAmounts = (totalUsd, { location, exchangeRate }) => {
  if (location === 'india') {
    const basePrice = totalUsd * exchangeRate;
    const gst = basePrice * 0.18;
    return {
      basePrice: basePrice.toFixed(2),
      gst: gst.toFixed(2),
      total: (basePrice + gst).toFixed(2),
    };
  }
  return {
    basePrice: totalUsd.toFixed(2),
    gst: '0',
    total: totalUsd.toFixed(2),
  };
};

export const toPaymentMinorUnits = (totalUsd, { location, exchangeRate }) => {
  const amounts = toCheckoutAmounts(totalUsd, { location, exchangeRate });
  return Math.round(parseFloat(amounts.total) * 100);
};

const computeSliderPrice = (basePrice, sliderValue, priceIncrement) =>
  basePrice + (sliderValue - 1) * priceIncrement;
